import { useUser } from '../../userManagement/userProvider/UserProvider'
import { trovaElementoConUUID } from '../utils'

function fixListaAgenti(listaAgenti, agentiTutti) {
  return listaAgenti.map(agente => {
    const { matricola, username } = agente

    return getAgenteConMatricola(matricola, agentiTutti)
      ?? getAgenteConUsername(username, agentiTutti)
      ?? agente
  })
}

function getAgenteConMatricola(matricola, agentiTutti) {
  return trovaElementoConUUID(agentiTutti, matricola, 'matricola')
}

function getAgenteConUsername(username, agentiTutti) {
  return trovaElementoConUUID(agentiTutti, username, 'username')
}

function useAgenteCorrente(agentiTutti) {
  const { userInfo: { info } } = useUser()
  
  function getAgenteCorrente() {
    return getAgenteConUsername(info.nickname, agentiTutti)
  }

  return { getAgenteCorrente }
}

export {
  fixListaAgenti,
  getAgenteConUsername,
  useAgenteCorrente,
}